import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Card, {
  ButtonWrapper,
  LoaderWrapper,
} from "../../components/Cards/Card";

import LayoutCardsWrapper from "../../components/LayoutCardsWrapper/LayoutCardsWrapper";
import CardWrapper from "../../components/LayoutCardsWrapper/CardWrapper";
import KpiCardEvolution from "../../components/KPI/KpiCardEvolution";
import { Grid, IconButton, Modal, Tooltip, Button } from "@mui/material";
import NativeObject from "../../components/NativeObject/NativeObject";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useSelections } from "../../context/Selections";
import TooltipInfo from "../../components/TooltipInfo/TooltipInfo";
import CircleLoader from "../../components/Loaders/CircleLoader";

function EvolutionMobile({ app, config }) {
  const { container } = config?.evolution;
  const [openModal, setOpenModal] = useState(false);
  const filterLabelStyle = {
    color: "#262626",
    fontSize: "16px",
    fontWeight: "700",
  };
  const { selections, setSelections } = useSelections();
  const [loadingExcel, setLoadingExcel] = useState(false);

  const exportToXLS = async (objectId, exportContainer = null) => {
    setLoadingExcel(false);
    let id = objectId;
    if (exportContainer) {
      await app.visualization
        .get(objectId)
        .then((vis) => {
          id = vis.model.items.activeId;
        })
        .catch(() => setLoadingExcel(false));
    }

    if (app && id) {
      setLoadingExcel(true);
      await app.visualization
        .get(id)
        .then((vis) => {
          vis.table.exportData({ format: "OOXML", state: "A" }).then((link) => {
            setLoadingExcel(false);
            const xlsLink = `https://qsense.mtrix.com.br:443${link.substring(
              link.indexOf("/tempcontent")
            )}`;
            window.open(xlsLink);
          });
        })
        .catch(() => setLoadingExcel(false));
    }
  };

  return (
    <div className="app evolution">
      <div className="appContent">
        <LayoutCardsWrapper>
          {container[0].cards.map((card, index) => {
            return (
              <CardWrapper
                customStyle={{
                  minHeight: "140px",
                  height: "12vh",
                  marginTop: "6px",
                }}
              >
                <KpiCardEvolution
                  key={index}
                  app={app}
                  KPITitle={{
                    hardTitle: card.title.hardTitle,
                    tooltip: card.title.tooltip,
                  }}
                  iconId={card.nativeObject.iconId}
                  percentageId={card.nativeObject.percentageId}
                  greyValueId={card.nativeObject.greyValueId}
                  valueId={card.nativeObject.valueId}
                ></KpiCardEvolution>
              </CardWrapper>
            );
          })}
          <CardWrapper customStyle={{ height: "150vh" }}>
            <Card
              style={{
                width: "100%",
                height: "100%",
              }}
            >
              <Grid
                container
                flexDirection={"column"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                rowGap={2}
              >
                <Grid
                  container
                  flexDirection={"column"}
                  justifyContent={"flex-start"}
                  alignItems={"flex-start"}
                  sx={{ height: "264px" }}
                >
                  <Grid
                    item
                    xs
                    sx={{
                      maxHeight: "50px",
                    }}
                  >
                    <ComboHeader
                      reference={{
                        title: {
                          hard: container[1].cards[0].title.hardTitle,
                        },
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    container
                    flexDirection={"column"}
                    justifyContent={"flex-start"}
                    alignItems={"flex-start"}
                    xs
                  >
                    <Grid
                      item
                      container
                      flexDirection={"row"}
                      justifyContent={"space-between"}
                      alignItems={"flex-start"}
                      columnGap={1}
                      xs
                    >
                      <Grid item xs={10}>
                        <NativeObject
                          style={{
                            marginTop: "-6px",
                            height: "40px",
                          }}
                          app={app}
                          key={"dUxaPKA"}
                          reference={{ id: "dUxaPKA" }}
                        />
                      </Grid>
                      <Grid item xs sx={{ padding: "4px 0 0 4px" }}>
                        <TooltipInfo text={container[1].cards[0].tooltips[0]} />
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      flexDirection={"row"}
                      justifyContent={"flex-start"}
                      alignItems={"flex-start"}
                      columnGap={1}
                      xs
                    >
                      <Grid item xs={10}>
                        <NativeObject
                          style={{
                            marginTop: "-6px",
                            height: "40px",
                          }}
                          app={app}
                          key={"QZnDaPw"}
                          reference={{ id: "QZnDaPw" }}
                        />
                      </Grid>
                      <Grid item xs sx={{ padding: "4px 0 0 4px" }}>
                        <TooltipInfo text={container[1].cards[0].tooltips[1]} />
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      flexDirection={"row"}
                      justifyContent={"flex-start"}
                      alignItems={"flex-start"}
                      columnGap={1}
                      xs
                    >
                      <Grid item xs={10}>
                        <NativeObject
                          style={{
                            marginTop: "-6px",
                            height: "40px",
                          }}
                          app={app}
                          key={"qwxhZk"}
                          reference={{ id: "qwxhZk" }}
                        />
                      </Grid>
                      <Grid item xs sx={{ padding: "4px 0 0 4px" }}>
                        <TooltipInfo text={container[1].cards[0].tooltips[2]} />
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      flexDirection={"row"}
                      justifyContent={"flex-start"}
                      alignItems={"flex-start"}
                      columnGap={1}
                      xs
                    >
                      <Grid item xs={10}>
                        <NativeObject
                          style={{
                            marginTop: "-6px",
                            height: "40px",
                          }}
                          app={app}
                          key={"sHAAAJf"}
                          reference={{ id: "sHAAAJf" }}
                        />
                      </Grid>
                      <Grid item xs sx={{ padding: "4px 4px 0 4px" }}>
                        <TooltipInfo text={container[1].cards[0].tooltips[3]} />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  container
                  flexDirection={"column"}
                  justifyContent={"flex-start"}
                  alignItems={"flex-start"}
                  sx={{ height: "960px" }}
                  rowGap={10}
                >
                  <Grid
                    item
                    container
                    flexDirection={"row"}
                    justifyContent={"flex-end"}
                    alignItems={"flex-end"}
                    sx={{
                      height: "400px",
                    }}
                    rowGap={2}
                    xs
                  >
                    <ButtonWrapper>
                      <Tooltip title="Exportar para Excel">
                        <IconButton
                          type="button"
                          onClick={() => exportToXLS("BaHAufh", true)}
                        >
                          {!loadingExcel ? (
                            <i className="far fa-file-export" />
                          ) : (
                            <LoaderWrapper>
                              <CircleLoader />
                            </LoaderWrapper>
                          )}
                        </IconButton>
                      </Tooltip>
                    </ButtonWrapper>

                    <NativeObject
                      app={app}
                      key={"BaHAufh"}
                      reference={{ id: "BaHAufh" }}
                      type={"barchart"}
                    />
                  </Grid>
                  <Grid
                    item
                    container
                    flexDirection={"row"}
                    justifyContent={"flex-end"}
                    alignItems={"flex-end"}
                    sx={{
                      height: "400px",
                    }}
                    rowGap={2}
                    xs
                  >
                    <ButtonWrapper>
                      <Tooltip title="Exportar para Excel">
                        <IconButton
                          type="button"
                          onClick={() => exportToXLS("PmrKhtD", true)}
                        >
                          {!loadingExcel ? (
                            <i className="far fa-file-export" />
                          ) : (
                            <LoaderWrapper>
                              <CircleLoader />
                            </LoaderWrapper>
                          )}
                        </IconButton>
                      </Tooltip>
                    </ButtonWrapper>

                    <NativeObject
                      app={app}
                      key={"PmrKhtD"}
                      reference={{ id: "PmrKhtD" }}
                      type={"barchart"}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </CardWrapper>
          <CardWrapper
            customStyle={{
              height: "64vh",
              marginTop: "18px",
              marginBottom: "36px",
            }}
          >
            <Card
              app={app}
              style={{
                width: "100%",
                height: "100%",
              }}
            >
              <Grid
                container
                flexDirection={"column"}
                justifyContent={"flex-start"}
                alignItems={"center"}
                rowGap={2}
              >
                <Grid
                  container
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Grid item xs>
                    <ComboHeader
                      reference={{
                        title: {
                          hard: container[1].cards[1].title.hardTitle,
                        },
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    container
                    flexDirection={"row"}
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    xs={5}
                  >
                    <Grid item xs={3.5}>
                      <IconButton
                        variant="text"
                        onClick={() => setOpenModal(true)}
                        sx={{
                          color: "#0190d2",
                          padding: "0",
                        }}
                      >
                        <FilterAltOutlinedIcon />
                      </IconButton>
                    </Grid>
                    <Grid item xs={3.5}>
                      <TooltipInfo text={container[1].cards[1].tooltips[0]} />
                    </Grid>
                    <Grid
                      item
                      xs
                      container
                      flexDirection={"row"}
                      justifyContent={"flex-end"}
                    >
                      <ButtonWrapper>
                        <Tooltip title="Exportar para Excel">
                          <IconButton
                            type="button"
                            onClick={() =>
                              exportToXLS(
                                "bcd353e2-9b4a-43fb-85ec-370dcd95ca80"
                              )
                            }
                          >
                            {!loadingExcel ? (
                              <i className="far fa-file-export" />
                            ) : (
                              <LoaderWrapper>
                                <CircleLoader />
                              </LoaderWrapper>
                            )}
                          </IconButton>
                        </Tooltip>
                      </ButtonWrapper>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                  alignItems={"flex-start"}
                >
                  <Grid
                    item
                    sx={{
                      height: "480px",
                      overflow: "scroll",
                    }}
                    xs
                  >
                    <NativeObject
                      app={app}
                      key={"bcd353e2-9b4a-43fb-85ec-370dcd95ca80"}
                      reference={{ id: "bcd353e2-9b4a-43fb-85ec-370dcd95ca80" }}
                      type={"table"}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Card>
            {openModal && (
              <Modal open={openModal} onClose={() => setOpenModal(false)}>
                <Grid
                  className="card"
                  container
                  flexDirection={"row"}
                  justifyContent={"flex-start"}
                  sx={{
                    overflowY: "scroll",
                    top: "40%",
                    left: "50%",
                    transform: "translate(-50%, -75%)",
                    position: "absolute",
                    height: "50%",
                    width: "70%",
                  }}
                >
                  <Grid
                    container
                    item
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    alignItems={"flex-start"}
                    sx={{
                      height: "10%",
                      width: "100%",
                      maxWidth: "100%",
                    }}
                  >
                    <Grid item xs>
                      <ComboHeader
                        reference={{
                          title: {
                            hard: "Filtros",
                          },
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      container
                      flexDirection={"row"}
                      justifyContent={"flex-end"}
                      alignItems={"flex-start"}
                      xs
                      sx={{
                        paddingBottom: "18px",
                      }}
                    >
                      <Tooltip title="Fechar">
                        <IconButton
                          type="button"
                          onClick={() => setOpenModal(false)}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    item
                    flexDirection={"row"}
                    justifyContent={"flex-start"}
                    alignItems={"center"}
                    xs
                  >
                    <Grid
                      item
                      container
                      flexDirection={"row"}
                      justifyContent={"flex-start"}
                      alignItems={"flex-start"}
                      columnGap={1}
                      xs={12}
                      sx={{
                        marginBottom: "-10px",
                      }}
                    >
                      <Grid
                        item
                        container
                        flexDirection={"column"}
                        justifyContent={"flex-start"}
                        alignItems={"flex-start"}
                        rowGap={1}
                        xs
                      >
                        <span style={filterLabelStyle}>PDVs</span>
                        <NativeObject
                          style={{
                            height: "60px",
                          }}
                          app={app}
                          key={"KRrEzS"}
                          reference={{ id: "KRrEzS" }}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      flexDirection={"row"}
                      justifyContent={"flex-start"}
                      alignItems={"flex-start"}
                      columnGap={1}
                      xs={12}
                      sx={{
                        marginBottom: "-10px",
                      }}
                    >
                      <Grid
                        item
                        container
                        flexDirection={"column"}
                        justifyContent={"flex-start"}
                        rowGap={1}
                        alignItems={"flex-start"}
                        xs
                      >
                        <span style={filterLabelStyle}>Cidades</span>
                        <NativeObject
                          style={{
                            height: "60px",
                          }}
                          app={app}
                          key={"vGbxnd"}
                          reference={{ id: "vGbxnd" }}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      flexDirection={"row"}
                      justifyContent={"flex-start"}
                      alignItems={"flex-start"}
                      columnGap={1}
                      xs={12}
                      sx={{
                        marginBottom: "-10px",
                      }}
                    >
                      <Grid
                        item
                        container
                        flexDirection={"column"}
                        justifyContent={"flex-start"}
                        rowGap={1}
                        alignItems={"flex-start"}
                        xs
                      >
                        <span style={filterLabelStyle}>UF</span>
                        <NativeObject
                          style={{
                            height: "60px",
                          }}
                          app={app}
                          key={"eDmTjT"}
                          reference={{ id: "eDmTjT" }}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      container
                      flexDirection={"row"}
                      justifyContent={"flex-start"}
                      alignItems={"flex-start"}
                      columnGap={1}
                      xs={12}
                      sx={{
                        marginBottom: "-10px",
                      }}
                    >
                      <Grid
                        item
                        container
                        flexDirection={"column"}
                        justifyContent={"flex-start"}
                        alignItems={"flex-start"}
                        rowGap={1}
                        xs
                      >
                        <span style={filterLabelStyle}>Segmento</span>
                        <NativeObject
                          style={{
                            height: "60px",
                          }}
                          app={app}
                          key={"RgPmmv"}
                          reference={{ id: "RgPmmv" }}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      container
                      flexDirection={"row"}
                      justifyContent={"flex-start"}
                      alignItems={"flex-start"}
                      columnGap={1}
                      xs={12}
                      sx={{
                        marginBottom: "-10px",
                      }}
                    >
                      <Grid
                        item
                        container
                        flexDirection={"column"}
                        justifyContent={"flex-start"}
                        rowGap={1}
                        alignItems={"flex-start"}
                        xs
                      >
                        <span style={filterLabelStyle}>Produtos</span>
                        <NativeObject
                          style={{
                            height: "60px",
                          }}
                          app={app}
                          key={"ENFZXGe"}
                          reference={{ id: "ENFZXGe" }}
                        />
                      </Grid>
                      <Grid
                        item
                        container
                        flexDirection={"column"}
                        justifyContent={"flex-start"}
                        rowGap={1}
                        alignItems={"flex-start"}
                        xs={12}
                        sx={{
                          marginBottom: "-10px",
                        }}
                      >
                        <span style={filterLabelStyle}>Distribuidores</span>
                        <NativeObject
                          style={{
                            height: "60px",
                          }}
                          app={app}
                          key={"TPNrqQm"}
                          reference={{ id: "TPNrqQm" }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    flexDirection={"row"}
                    justifyContent={"flex-start"}
                    alignItems={"flex-end"}
                    sx={{
                      marginTop: "24px",
                    }}
                  >
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        onClick={() => setOpenModal(false)}
                        fullWidth
                      >
                        <span
                          style={{
                            textTransform: "capitalize",
                          }}
                        >
                          Aplicar filtros
                        </span>
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <Button variant="text" fullWidth>
                        <span
                          style={{
                            borderBottom: "1px solid #262626",
                            color: "#262626",
                            textTransform: "capitalize",
                          }}
                        >
                          Limpar seleção
                        </span>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Modal>
            )}
          </CardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

EvolutionMobile.defaultProps = {
  app: null,
  config: {},
};

EvolutionMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default EvolutionMobile;
